import { CircleBrokenIcon } from "@navikt/aksel-icons";
import { useTranslation } from "react-i18next";

export const DescriptionTerm = ({
  tranlsationFeltKey,
  value,
  isLoading = false,
}: {
  tranlsationFeltKey: string;
  value: string | number | null | undefined;
  isLoading?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col sm:flex-row sm:gap-2 mb-2 md:mb-0">
      <dt className="font-semibold">{t(tranlsationFeltKey)}:</dt>
      <dd className="m-0 whitespace-pre-line break-all text-pretty">
        {isLoading ? (
          <span className="flex gap-1 items-center">
            <CircleBrokenIcon className="animate-spin" />
            {t("pages.oppsummering.laster")}
          </span>
        ) : (
          <span>{value ?? t("pages.oppsummering.ikke-utfylt")}</span>
        )}
      </dd>
    </div>
  );
};
